module.exports = __webpack_public_path__ + "static/page-banner-product-mobile-development-b041c578cc79e58b81e8d3cfa1126ad9.png";